import Vue from 'vue';

export default {
	getAreas(state) {
		return state.areas;
	},
	getClassSteps(state) {
		return state.classSteps;
	},
	getPolls(state) {
		return state.polls;
	},
	getUid(state) {
		return state.uid;
	},
	getCurrentPollId(state) {
		return state.currentPollId;
	},
	getError(state) {
		return state.error;
	}
}